/**
 * Created by amirb on 7/27/15.
 */
/**
 * Created by amirb on 7/26/15.
 */
define(function (require) {

    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var TableViewController = require('web-agent-framework/TableViewController');
    var ViewController = require('web-agent-framework/ViewController');


    var SlaChangerListViewController = ViewController.extend({
        ControllerName: 'SlaChangerListViewController',

        LPViewMap: {
            listViewContainer: '.lpview_listview_container',
            filterArea: '.lpview_filterArea'
        },
        LPClassesMap: {},
        LPTemplatesFiles: {
            listItem: 'LP_sla_changer_list_item.html'
        },

        initialize: function (constructorData) {
            this.focusedView = constructorData.view;
            this.items = this.initValue();
            this.closeDropUp = constructorData.closeDropUp;
            this.updateChatId(constructorData.chatId);
            this.initializeTableView();
        },

        events: function () {
        },

        render: function () {

        }
    });

    SlaChangerListViewController.prototype.updateChatId = function (chatId) {
        if (chatId) {
            this.chatId = chatId;
        }
    };

    SlaChangerListViewController.prototype.initValue = function () {
        var toReturn = [];
        toReturn.push({text:this.translateObj('MANUAL_SLA_x_minutes', [30]), inMiliSec:1800000});
        toReturn.push({text:this.translate('MANUAL_SLA_1_hour'), inMiliSec:3600000 });
        toReturn.push({text:this.translateObj('MANUAL_SLA_x_hours', [2]), inMiliSec:7200000});
        toReturn.push({text:this.translate('MANUAL_SLA_1_day'), inMiliSec:86400000});

        return toReturn;
    };

    SlaChangerListViewController.prototype.toggleSelectedValue = function (data) {
        this.closeDropUp();
        this.modelController.setManualSla(this.chatId, data.inMiliSec);
    };

    SlaChangerListViewController.prototype.initializeTableView = function () {
        var self = this;
        var dataBinder = {
            modelDataChanged: function () {
                BaseTableViewController.prototype.baseTableBodyDataBinder.modelDataChanged.apply(this, arguments);
            },
            operationCanceled: function () {
                BaseTableViewController.prototype.baseTableBodyDataBinder.operationCanceled.apply(this, arguments);
            },
            rowSelected: function (data) {
                BaseTableViewController.prototype.baseTableBodyDataBinder.rowSelected.apply(this, arguments);
            },
            rowClicked: function (data, view, event) {
                self.toggleSelectedValue(data.rowData);
                BaseTableViewController.prototype.baseTableBodyDataBinder.rowClicked.apply(this, arguments);
            }
        };

        var dataRenderer = {
            numberOfSections: function () {
                return 1;
            },

            numberOfRowsInSection: function (data) {
                return data.length;
            },

            dataForSection: function () {
                return;
            },

            dataForRowInSection: function (data, rowIndex) {
                var rowData = data[rowIndex];
                var value = {text: "", rowData: rowData, id: rowIndex};
                value.text = rowData.text;
                return value;
            },

            getPropertiesForHighlight: function () {
                return {text: true};
            }
        };


        // Creating the Table.
        this.listViewVC = new TableViewController({
            ControllerName: "TableViewController(SlaChangerListViewController)",
            context: this,
            rowTemplateFile: this.LPTemplatesFiles.listItem,
            modelData: this.items,
            dataRenderer: dataRenderer,
            dataBinder: dataBinder,
            modelController: this.modelController,
            supportKeysNavigation: true,
            focusedView: this.focusedView

        });
        this.addViewController({viewController: this.listViewVC, target: '.lpview_predifend_sla_list_placeholder'});

    };

    return SlaChangerListViewController;

});
